import { useMemo } from 'react'
import { PostFormat, usePost } from 'sharedKernel/api'
import {
  MEETING_ROOM_API,
} from '../../manage-meeting-room/api/constants'
import { buildMeetingRoomListPayload } from '../../manage-meeting-room/api/listRequest'
import { normalizeMeetingRoomListResponse } from '../../manage-meeting-room/api/mappers'
import { MeetingRoomSpaceOption } from '../EditReservationModal'

export const useMeetingRoomSpaceOptions = (currentMeetingRoomId?: string) => {
  const listRequest: PostFormat = useMemo(
    () => ({
      url: MEETING_ROOM_API.ALL,
      data: buildMeetingRoomListPayload({}),
    }),
    []
  )

  const { data, isLoading, isFetching } = usePost<unknown>(
    listRequest,
    'meeting-room-space-options'
  )

  const spaceOptions = useMemo((): MeetingRoomSpaceOption[] => {
    const rooms = normalizeMeetingRoomListResponse(data)

    return rooms
      .filter(room => !room.isHidden || room.id === currentMeetingRoomId)
      .map(room => ({
        id: room.id,
        name: room.name,
      }))
      .filter(option => option.id !== '')
  }, [currentMeetingRoomId, data])

  return {
    spaceOptions,
    isLoading,
    isFetching,
  }
}
